import type { VirtualAppointmentDto } from '../../services/virtualAppointments';
import { AssigneeDisplay } from '../conversations/AssigneeDisplay';
import { TeamPill } from '@odo/shared-ui/components/TeamPill';
import {
    NO_ASSIGNEE_LABEL,
    useVirtualAppointmentAssigneeName
} from './useVirtualAppointmentAssigneeName';
import { VIRTUAL_APPOINTMENT_STATUS_LABELS } from '@odo/shared-ui/clinical/virtualAppointments/summary';
import { virtualAppointmentStatusBg } from './virtualAppointmentStatusColors';

interface VirtualAppointmentRowBadgesProps {
    va: Pick<VirtualAppointmentDto, 'status' | 'team' | 'assigneeEmail'>;
}

// A folded row's status, team and assignee at a glance; the open card has the full controls.
export function VirtualAppointmentRowBadges({ va }: VirtualAppointmentRowBadgesProps) {
    const statusLabel = VIRTUAL_APPOINTMENT_STATUS_LABELS[va.status];
    const assigneeName = useVirtualAppointmentAssigneeName(va.team, va.assigneeEmail);
    return (
        <span className="flex flex-shrink-0 items-center gap-1.5">
            <span
                role="img"
                aria-label={statusLabel}
                title={statusLabel}
                className={`w-2 h-2 rounded-full ${virtualAppointmentStatusBg(va.status)}`}
            />
            <TeamPill team={va.team} size="xs" />
            <AssigneeDisplay
                name={assigneeName}
                email={va.assigneeEmail}
                variant="avatar"
                unassignedLabel={NO_ASSIGNEE_LABEL}
            />
        </span>
    );
}
